module.exports = __webpack_public_path__ + "img/home-solution-ziran.e2a587c6.png";